import * as v from "valibot";

import { rpcContract } from "../rpc";

export const createCreatorRpcContract = rpcContract({
  name: "createCreator",
  paramsSchema: v.object({
    handle: v.pipe(
      v.string(),
      v.minLength(3, "Handle must be at least 3 characters"),
      v.maxLength(64, "Handle must be at most 64 characters"),
      v.regex(/^[a-z0-9_\-.]+$/, "Handle can only contain lowercase letters, numbers, underscores, dots, and hyphens"),
    ),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    influencerId: v.string(),
    message: v.string(),
  }),
});

export type CreateCreatorParams = v.InferOutput<(typeof createCreatorRpcContract)["paramsSchema"]>;
export type CreateCreatorResult = v.InferOutput<(typeof createCreatorRpcContract)["resultSchema"]>;
